import { CardActions as NovaCardActions, CardActionsProps as NovaCardActionsProps } from '@fme-nova/components'
import { CardActionsProps as MuiCardActionsProps, default as MuiCardActions } from '@mui/material/CardActions'

import { createComponentWrapperWithRef } from '../../theme'

export const CardActions = createComponentWrapperWithRef<MuiCardActionsProps | NovaCardActionsProps>(
  {
    mui: MuiCardActions,
    nova: NovaCardActions,
  },
  'CardActions',
)
